import "@google/model-viewer";
import { memo } from "react";

const ThreeDViewer = ({ url }) => {
	return (
		<model-viewer
			style={{
				width: "100%",
				height: "100%",
			}}
			camera-controls
			src={URL.createObjectURL(url)}
		/>
	);
};

export default memo(ThreeDViewer);
